import React from 'react';
import { CardProgress } from '@brokerbay/design-components';

interface OnboardingProgressProps {
  step: number;
}

const Epic1CardProgress = ({ step }: OnboardingProgressProps) => (
  <CardProgress percent={(step / 6) * 100} />
);

export default Epic1CardProgress;
